<style scoped="scoped" lang="scss">
    .read_title {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
    margin-top: 36px;
    font-size: 16px;
    font-family: Microsoft YaHei UI;
    color: #303133;

  }
</style>

<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" getUrl="/web/process/flow/page" ref="yt" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('zhuangtai')">
            <el-select v-model="yt.conditions.approvalStatus">
              <el-option :value="0" :label="$t('待审核')"></el-option>
              <el-option :value="1" :label="$t('审核通过')"></el-option>
              <el-option :value="2" :label="$t('审核不通过')"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="searchBtn()" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="clear()">{{ $t('chongzhi') }}</el-button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL="scope"> </template>
      <!-- 类型 插槽-->
      <template #leixing="scope">
        {{$t(scope.row.bizType)}}
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('xiaoxiqiangqing', scope.row,'1300px')">
              {{ $t('chakan') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <!-- 查看/消息详情 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <div class="dialog-scroller">
        <div style="width: 100%;height: 1px;border: 1px solid #E4E7ED;"></div>
        <div class="read_title">
          {{this.yt.editObj.title}}
        </div>
        <!-- 申请时间，申请人 -->
        <div style="display: flex;flex-wrap: nowrap;color: #606266;justify-content: center;align-items: center;margin-top: 18px">
          <span> {{$t('申请人')}}: {{this.yt.editObj.promoterName}} </span>
          <span style="margin-left: 30px"> {{$t('申请时间')}}: {{dayjs(this.yt.editObj.promoterTime).format('YYYY-MM-DD HH:mm')}} </span>
          <span style="margin-left: 30px"> {{$t('审核状态')}}: {{getApprovalStatusDesc(this.yt.editObj.approvalStatus)}} </span>
        </div>
        <!--内容-->
        <div style="margin: 40px; color: #606266">
          {{this.yt.editObj.bizMsg}}
        </div>
        <!--下发信息详情-->
        <div>
          <see-adjusting ref="seeAdjustingRef" @dialogClose="yt.isShowEditDialog = false" :formLabelWidth="yt.formLabelWidth" :id="yt.editObj.bizId"></see-adjusting>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import seeAdjusting from '@@/pages/web/process_distribution/adjusting_record/see_adjusting.vue';

  export default {
    name: 'web_system_message_process_message',
    components: {
      seeAdjusting
    },
    data() {
      return {
        conditions: {
          approvalStatus: null
        },
        columns: [
          {
            label: 'shenhezhuangtai',
            prop: 'approvalStatus',
            type: 'tag',
            width: 100,
            tags: {
              0: {
                color: '#E6A23C',
                text: this.$t('shenhezhong')
              },
              1: {
                color: '#67C23A',
                text: this.$t('shehechenggong')
              },
              2: {
                color: '#F56C6C',
                text: this.$t('shenheshibai')
              },
              3: {
                color: '#909399',
                text: this.$t('yichehui')
              }
            },
            },
            {
              label: 'leixing',
              type: 'slot',
              width: 120
            },
             {
              label: 'xiaoxibiaoti',
              prop: 'title',
            },
            {
              label: 'miaoshu',
              prop: 'bizMsg',
            },
            {
              label: 'shenqingshijian',
              prop: 'promoterTime',
              type: 'time',
            }, {
              label: 'shenqingren',
              prop: 'promoterName',
              fixed: 'right'
            },{
              label: 'caozuo',
              type: 'slot',
              fixed: 'right'
            }
          ]

        }
      }, methods: {
          getApprovalStatusDesc(status){
              switch (status) {
                case '0':
                  return '审批中';
                case '1':
                  return '审批通过';
                case '2':
                  return '审批不通过';
                case '3':
                  return '撤回';
            }
          },
          searchBtn(){
            this.yt.get(1);
          },
          clear() {
            this.conditions.approvalStatus = null,
            this.yt.conditions = this.conditions
            this.yt.get(1)
        },
      }, created() {
          setTimeout(() => {
            this.yt.conditions = {
              orderBy: 'id desc',
            };
            this.yt.get(1);
        }, 300)

      }
    }
</script>
